function loadVisiblePanelImages(panel) {
  panel.querySelectorAll('img').forEach((image) => {
    const sizes = image.getAttribute('sizes');
    const src = image.getAttribute('src');
    const srcset = image.getAttribute('srcset');

    if (image.loading === 'lazy') image.loading = 'eager';
    if (sizes?.startsWith('auto,')) {
      image.setAttribute('sizes', sizes.replace(/^auto,\s*/, ''));
    }

    if (!image.complete) {
      if (srcset) image.setAttribute('srcset', srcset);
      if (src) image.setAttribute('src', src);
    }
  });
}

function revealProductCardMedia(panel) {
  panel.querySelectorAll('.card-gallery slideshow-component').forEach((gallery) => {
    const visibleSlides = Array.from(gallery.querySelectorAll('slideshow-slide.product-media-container:not([hidden])'));
    const slides = visibleSlides.length
      ? visibleSlides
      : Array.from(gallery.querySelectorAll('slideshow-slide.product-media-container'));

    gallery.setAttribute('actioned', '');

    slides.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', `${index !== 0}`);
      slide.style.contentVisibility = index === 0 ? 'visible' : '';
    });
  });
}

function selectProductListTab(tab) {
  const root = tab.closest('[data-product-list-tabs-root]');
  const tabId = tab.dataset.productListTab;

  if (!root || !tabId) return;

  const tabs = Array.from(root.querySelectorAll('[data-product-list-tab]'));
  const panels = Array.from(root.querySelectorAll('[data-product-list-panel]'));
  const activePanel = panels.find((panel) => panel.dataset.productListPanel === tabId);

  tabs.forEach((item) => {
    const isActive = item.dataset.productListTab === tabId;
    item.setAttribute('aria-selected', `${isActive}`);
    item.tabIndex = isActive ? 0 : -1;
  });

  panels.forEach((panel) => {
    const isActive = panel.dataset.productListPanel === tabId;
    panel.hidden = !isActive;
    panel.classList.toggle('is-active', isActive);
  });

  if (!activePanel) return;

  requestAnimationFrame(() => {
    const slideshow = activePanel.querySelector('slideshow-component');
    const scroller = activePanel.querySelector('slideshow-slides');

    revealProductCardMedia(activePanel);
    loadVisiblePanelImages(activePanel);
    if (scroller) scroller.scrollLeft = 0;
    slideshow?.select?.(0, undefined, { animate: false });
    window.dispatchEvent(new Event('resize'));
  });
}

function initializeProductListTabs(root = document) {
  const tabRoots = root.matches?.('[data-product-list-tabs-root]')
    ? [root]
    : Array.from(root.querySelectorAll('[data-product-list-tabs-root]'));

  tabRoots.forEach((tabRoot) => {
    const activeTab =
      tabRoot.querySelector('[data-product-list-tab][aria-selected="true"]') ||
      tabRoot.querySelector('[data-product-list-tab]');

    if (activeTab) selectProductListTab(activeTab);
  });
}

document.addEventListener('click', (event) => {
  const tab = event.target.closest('[data-product-list-tab]');

  if (!tab) return;

  event.preventDefault();
  selectProductListTab(tab);
});

document.addEventListener('keydown', (event) => {
  const tab = event.target.closest('[data-product-list-tab]');

  if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

  const tabs = Array.from(
    tab.closest('[data-product-list-tabs-root]')?.querySelectorAll('[data-product-list-tab]') || []
  );
  const currentIndex = tabs.indexOf(tab);
  let nextIndex = currentIndex;

  if (event.key === 'ArrowLeft') nextIndex = Math.max(0, currentIndex - 1);
  if (event.key === 'ArrowRight') nextIndex = Math.min(tabs.length - 1, currentIndex + 1);
  if (event.key === 'Home') nextIndex = 0;
  if (event.key === 'End') nextIndex = tabs.length - 1;

  if (nextIndex === currentIndex) return;

  event.preventDefault();
  tabs[nextIndex].focus();
  selectProductListTab(tabs[nextIndex]);
});

initializeProductListTabs();

document.addEventListener('shopify:section:load', (event) => {
  initializeProductListTabs(event.target);
});
